import React, { useState, useLayoutEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import HeaderBar from "./HeaderBar";

import { Link } from "react-router-dom";

export default function AppLayout() {



  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const location = useLocation();

  const getTitle = () => {
    if (location.pathname.startsWith("/agents")) return "Agents";
    if (location.pathname.startsWith("/profile")) return "Profile";
    if (location.pathname.startsWith("/leads")) return "Leads";
    if (location.pathname.startsWith("/dashboard")) return "Dashboard";
    if (location.pathname.startsWith("/register")) return "Register";
    return "";
  };





  useLayoutEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setMobileOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleMobileSidebar = () => {
    setMobileOpen(!mobileOpen);
  };

  const toggleDesktopSidebar = () => {
    setCollapsed(!collapsed);
  };

  const closeMobileSidebar = () => {
    setMobileOpen(false);
  };

  return (
    <div className="layout">
      <Sidebar
        collapsed={collapsed}
        mobileOpen={mobileOpen}
        closeMobileSidebar={closeMobileSidebar}
        toggleDesktopSidebar={toggleDesktopSidebar}
      />

      <div className="main-wrapper">
        <HeaderBar toggleMobileSidebar={toggleMobileSidebar} title={getTitle()} />
        {/* Main Content Area */}
        <main className="app-main-content"> <Outlet /></main>
      </div>
      <footer className="app-footer">
        <Link
          to="/register"
          className="btn w-auto py-1 px-3 d-flex align-center text-sm fw-semibold bg-gradient-primary btn-hover-glow  floating-register mobile-only"
        >
          +
        </Link>
      </footer>
    </div>
  );
}
